import { useEffect, useRef, useState } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useDispatch, useSelector } from 'react-redux';
import BarChart from './charts';
import HeaderDashboard from './header-dashboard';
import Dtable from './table';
import DashboardFilter from './filter';
import TopInterfaces from './top-interfaces';
import MetricCharts from './metric-charts';
import NodesInfo from './nodes-info';
import {
  getDashboard,
  getDashboardDevices,
  getDashboardFirstSection,
  getDashboardGeneralTable,
  getDashboardIrregularNodes,
  getDashboardMetrics,
  getDashboardTopInterfaces,
  setDashboardFiltersSelected,
  setMetricThreshold, getChartsThresholds,
} from '../../store/fuse/dashboard';
import LoadingOverlay from '../loading-overlay';
import { getTopologicNodes } from '../../store/fuse/monitoreo';
import { getNotifications } from '../../theme-layouts/shared-components/notificationPanel/store/dataSlice';

function Dashboard() {
  const { keycloak } = useKeycloak();

  const roleKeycloak = keycloak?.realmAccess?.roles[0];
  const id = keycloak?.tokenParsed?.sub;
  const roleId = keycloak?.tokenParsed?.resource_access?.puv.roles[0];
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [inmueble, setInmueble] = useState('');
  const [region, setRegion] = useState('');
  const [grupo, setGrupo] = useState('');
  const [nodo, setNodo] = useState('');
  const [nodoInfo, setNodoInfo] = useState({});

  const [dateInit, setDateInit] = useState();
  const [dateEnd, setDateEnd] = useState();

  const { loadingFirstSection, loadingTopInterfaces, loadingGeneralTable, loadingIrregularNodes, loadingCaidasNodes, loadingDevices } = useSelector(
    (state) => state?.fuse?.dashboard
  );

  const { inmuebles, regiones, grupos, nodos } = useSelector((state) => state?.fuse?.filter?.filter?.filters);

  const loadingFilters = useSelector((state) => state?.fuse?.filter?.loading);
  const filtersSelected = useSelector((state) => state?.fuse?.dashboard?.dashboard?.filters?.filtersSelected);

  const previousFiltersSelectedRef = useRef(null);

  useEffect(() => {
    dispatch(setMetricThreshold());
    dispatch(getDashboard());
    dispatch(getDashboardMetrics());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
   if(!nodo){
     setNodoInfo({})
   }
  }, [nodo]);
  
  useEffect(() => {
    fetchAllData();
    const matchCurrentFiltersWithPreviousSelections = () => {
      if (filtersSelected.region) {
        const regionSelected = regiones.find((regionObj) => regionObj.regionId === filtersSelected.region);
        setRegion(regionSelected.regionId);
      }
      if (filtersSelected.grupo) {
        const groupSelected = grupos.find((grupoObj) => grupoObj.grupoInmuebleId === filtersSelected.grupo);
        setGrupo(groupSelected.grupoInmuebleId);
      }
      if (filtersSelected.inmueble) {
        const inmuebleSelected = inmuebles.find((grupoObj) => grupoObj.inmuebleId === filtersSelected.inmueble);
        setInmueble(inmuebleSelected.inmuebleId);
      }
      if (filtersSelected.nodo) {
        const nodoSelected = nodos.find((nodoObj) => nodoObj.nodeId === parseInt(filtersSelected.nodo, 10));
        setNodoInfo(nodoSelected)
        setNodo(nodoSelected.nodeId)
      }
    };
    matchCurrentFiltersWithPreviousSelections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersSelected]);

  useEffect(() => {
    previousFiltersSelectedRef.current = filtersSelected;
    const intervalId = setInterval(() => {
      const previousFiltersSelected = previousFiltersSelectedRef.current;
      setDateInit();
      setDateEnd();
      dispatch(
        setDashboardFiltersSelected({
          ...previousFiltersSelected
        })
      );
    }, 60000 * 5);
    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersSelected]);

  const fetchAllData = () => {
    dispatch(getNotifications({ idUser: id, roleId }));
    dispatch(getDashboardGeneralTable(filtersSelected));
    dispatch(getDashboardFirstSection(filtersSelected));
    dispatch(getDashboardDevices(filtersSelected));
    dispatch(getDashboardIrregularNodes(filtersSelected));
    dispatch(getDashboardTopInterfaces(filtersSelected));
    dispatch(getTopologicNodes(filtersSelected));
    dispatch(getChartsThresholds(filtersSelected))
  };

  useEffect(() => {
    if (
      !loadingFirstSection &&
      !loadingTopInterfaces &&
      !loadingGeneralTable &&
      !loadingIrregularNodes &&
      !loadingFilters &&
      !loadingDevices
    ) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [loadingFirstSection, loadingTopInterfaces, loadingGeneralTable, loadingIrregularNodes, loadingFilters, loadingDevices, loadingCaidasNodes]);

  return (
    <>
      <>
        <DashboardFilter
          currentFilters={{ inmueble, region, grupo, nodo, dateInit, dateEnd }}
          filtersSetters={{ setInmueble, setRegion, setGrupo, setNodo, setDateInit, setDateEnd }}
          filtersSelected={filtersSelected}
          setFilters={setDashboardFiltersSelected}
          fetchAllData={fetchAllData}
        />
        <div className="flex mb-4">
          <div style={{ width: '100%' }}>
            <HeaderDashboard filtersSelected={filtersSelected} redirect="/dashboard" />
            <BarChart />
            <NodesInfo />
          </div>
        </div>
        <div className="flex flex-row justify-center">
          <TopInterfaces />
        </div>
        <div className="mb-4 w-full">
          <MetricCharts
            nodoInfo={nodoInfo}
            currentFilters={{ dateInit, dateEnd }}
            setFilters={setDashboardFiltersSelected}
          />
        </div>
        <div className="p-10" style={{ marginTop: '5rem' }}>
          <Dtable type="dynamic" redirect="/dashboard" />
        </div>
      </>
      {loading && <LoadingOverlay />}
    </>
  );
}
export default Dashboard;
